
import { getApiVersion } from './config.js'
import { makeGetRequest, /* makePostRequest, makePutRequest, makeDeleteRequest */ } from './util.js'

const RELATIVE_PREFIX = 'route'

function getRouteMapPoints(routeId, date, queryParams) {
  var filteredQueryParams = {}
  if (queryParams?.loggedBefore) filteredQueryParams.logged_before = queryParams.loggedBefore
  return makeGetRequest(`${getApiVersion()}/${RELATIVE_PREFIX}/points/${routeId}/${date}`, filteredQueryParams)
}

function getRouteDetail(routeId, queryParams) {
  var filteredQueryParams = {}
  if (queryParams?.date) filteredQueryParams.date = queryParams.date
  return makeGetRequest(`${getApiVersion()}/${RELATIVE_PREFIX}/detail/${routeId}`, filteredQueryParams)
}

export {
  getRouteMapPoints,
  getRouteDetail,
}
